import { getNoticeList } from "@/api/grid";
// import { selectUser } from '@/api/user'
import { planCombo , planList } from '@/api/plan'
import { getCorCombo,selectCorList } from '@/api/cor'
import { noticeList } from '@/api/notice'
import { unionList } from '@/api/union'
import { referencList, expertList } from '@/api/room'
import { orgChartList } from '@/api/org'
import { popupList } from '@/api/popup'
import { faqList } from '@/api/faq'
import { qnaList , answerList  } from '@/api/qna'
import { eduList } from '@/api/edu'
import { bannerList } from '@/api/banner'
import { detailUser } from '@/api/user'
import { selectSurveyList } from '@/api/survey'
import noticeJson from '@/models/gridInfo/notice.json'
import userJson from '@/models/gridInfo/user.json'
import planJson from '@/models/gridInfo/plan.json'
import corJson from '@/models/gridInfo/cor.json'
import unionJson from '@/models/gridInfo/union.json'
import roomJson from '@/models/gridInfo/room.json'
import orgJson from '@/models/gridInfo/org.json'
import popupJson from '@/models/gridInfo/popup.json'
import faqJson from '@/models/gridInfo/faq.json'
import qnaJson from '@/models/gridInfo/qna.json'
import eduJson from '@/models/gridInfo/edu.json'
import bannerJson from '@/models/gridInfo/banner.json'
import surveyJson from '@/models/gridInfo/survey.json'
import expertJson from '@/models/gridInfo/expert.json'
export default {
  namespaced: true,
  state: {
    gridData: [],
    noticeData: [],
    unionData: [],
    referencData : [],
    adminData: [],
    userData: [],
    planComboData: [],
    planData: [],
    popupData: [],
    corComboData: [],
    corData: [],
    deptUserData: [],
    orgData: [],
    faqData: [],
    qnaData: [],
    eduData: [],
    surveyData: [],
    bannerData: [],
    answerData: [],
    expertData: [],
    pagination: {
      pageNo: 1,
      countPerRecord: 10,
    },
    paginationUser: {
      pageNo: 1,
      countPerRecord: 10,
    },
    paginationEdu: {
      pageNo: 1,
      countPerRecord: 10,
    },
  },
  mutations: {
    setGridData(state, payload) {
      state.gridData.push(payload);
    },
    clearGridData(state) {
      state.gridData.length = 0;
    },

    setNoticeData(state, payload) {
      state.noticeData.push(payload);
    },
    clearNoticeData(state) {
      state.noticeData.length = 0;
    },

    setExpertData(state, payload) {
      state.expertData.push(payload);
    },
    clearExpertData(state) {
      state.expertData.length = 0;
    },

    setDetailUserData(state, payload) {
      state.detailuserData.push(payload);
    },
    clearDetailUserData(state) {
      state.detailuserData.length = 0;
    },

    setBannerData(state, payload) {
      state.bannerData.push(payload);
    },
    clearBannerData(state) {
      state.bannerData.length = 0;
    },

    setPopupData(state, payload) {
      state.popupData.push(payload);
    },
    clearPopupData(state) {
      state.popupData.length = 0;
    },

    setEduData(state, payload) {
      state.eduData.push(payload);
    },
    clearEduData(state) {
      state.eduData.length = 0;
    },

    setQnaData(state, payload) {
      state.qnaData.push(payload);
    },
    clearQnaData(state) {
      state.qnaData.length = 0;
    },

    setAnswerDataData(state, payload) {
      state.answerData.push(payload);
    },
    clearAnswerDataData(state) {
      state.answerData.length = 0;
    },

    setFaqData(state, payload) {
      state.faqData.push(payload);
    },
    clearFaqData(state) {
      state.faqData.length = 0;
    },


    setOrgData(state, payload) {
      state.orgData.push(payload);
    },
    clearOrgData(state) {
      state.orgData.length = 0;
    },

    setUnionData(state, payload) {
      state.unionData.push(payload);
    },
    clearUnionData(state) {
      state.unionData.length = 0;
    },

    
    setReferencData(state, payload) {
      state.referencData.push(payload);
    },
    clearReferencData(state) {
      state.referencData.length = 0;
    },

    setAdminData(state, payload) {
      state.adminData.push(payload);
    },
    clearAdminData(state) {
      state.adminData.length = 0;
    },

    setPlanComboData(state, payload) {
      state.planComboData.push(payload);
    },
    clearPlanComboData(state) {
      state.planComboData.length = 0;
    },

    setPlanData(state, payload) {
      state.planData.push(payload);
    },
    clearPlanData(state) {
      state.planData.length = 0;
    },

    setCorComboData(state, payload) {
      state.corComboData.push(payload);
    },
    clearCorComboData(state) {
      state.corComboData.length = 0;
    },

    setCorData(state, payload) {
      state.corData.push(payload);
    },
    clearCorData(state) {
      state.corData.length = 0;
    },

    setUserData(state, payload) {
      state.userData.push(payload);
    },
    clearUserData(state) {
      state.userData.length = 0;
    },

    setSurveyData(state, payload) {
      state.surveyData.push(payload);
    },
    clearSurvey(state) {
      state.surveyData.length = 0;
    },

    setPagination(state, payload) {
      state.pagination = payload;
    },
    clearPagination(state) {
      state.pagination = {
        pageNo: 1,
      };
    },

    setPaginationUser(state, payload) {
      state.paginationUser = payload;
    },
    clearPaginationUser(state) {
      state.paginationUser = {
        pageNo: 1,
      };
    },

    setPaginationEdu(state, payload) {
      state.paginationEdu = payload;
    },
    clearPaginationEdu(state) {
      state.paginationEdu = {
        pageNo: 1,
      };
    },
  },
  actions: {
    async fetchNotice({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearGridData");
      commit('clearPagination');

      let rtn = {};
      rtn = await getNoticeList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of noticeJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setGridData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async detailUser({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearDetailUserData");
      commit('clearPagination');

      let rtn = {};
      rtn = await detailUser(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of userJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setDetailUserData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async popupList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearPopupData");
      commit('clearPagination');

      let rtn = {};
      rtn = await popupList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of popupJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setPopupData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async eduList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearEduData");
      commit('clearPagination');

      let rtn = {};
      rtn = await eduList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of eduJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setEduData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async bannerList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearBannerData");
      commit('clearPagination');

      let rtn = {};
      rtn = await bannerList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of bannerJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setBannerData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async qnaList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearQnaData");
      commit('clearPagination');

      let rtn = {};
      rtn = await qnaList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of qnaJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setQnaData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async answerList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearAnswerDataData");
      commit('clearPagination');

      let rtn = {};
      rtn = await answerList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of qnaJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setAnswerDataData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

     async faqList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearFaqData");
      commit('clearPagination');

      let rtn = {};
      rtn = await faqList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of faqJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setFaqData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },



    async noticeList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearNoticeData");
      commit('clearPagination');

      let rtn = {};
      rtn = await noticeList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of noticeJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setNoticeData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async expertList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearExpertData");
      commit('clearPagination');

      let rtn = {};
      rtn = await expertList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of expertJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setExpertData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async orgChartList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearOrgData");
      commit('clearPagination');

      let rtn = {};
      rtn = await orgChartList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of orgJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setOrgData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async referencList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearReferencData");
      commit('clearPagination');

      let rtn = {};
      rtn = await referencList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of roomJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setReferencData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async unionList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearUnionData");
      commit('clearPagination');

      let rtn = {};
      rtn = await unionList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of unionJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setUnionData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async selectUser({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearUserData");
      commit('clearPagination');

      let rtn = {};
      rtn = await selectUser(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of userJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setUserData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async planCombo({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearPlanComboData");
      commit('clearPagination');

      let rtn = {};
      rtn = await planCombo(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of planJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setPlanComboData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async planList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearPlanData");
      commit('clearPagination');

      let rtn = {};
      rtn = await planList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of planJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setPlanData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async corCombo({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearCorComboData");
      commit('clearPagination');

      let rtn = {};
      rtn = await getCorCombo(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of corJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setCorComboData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async fetchCor({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearCorData");
      commit('clearPagination');

      let rtn = {};
      rtn = await selectCorList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of corJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setCorData", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },

    async selectSurveyList({ state, commit }, payload) {
      //console.log("11111 공지사항 호출1111");
      commit("clearSurveyData");
      commit('clearPagination');

      let rtn = {};
      rtn = await selectSurveyList(payload);

      for (const vo of rtn?.data) {
        let dataObj = {};
        for (const info of surveyJson.cell) {
          dataObj[`${info.key}`] = vo[`${info.key}`];
        }
        commit("setSurveyata", dataObj);
      }

      commit("setPagination", rtn?.pagingBean);
    },
  },

};    